// extracted by mini-css-extract-plugin
module.exports = {"label_chip":"chip-module--label_chip--2r9tv","label_chip_not_clickable":"chip-module--label_chip_not_clickable--3I9Yz"};